import React from "react";

const Content = () => {
    return (
        <>
            <main id="body-content">
                <section className="wide-tb-80">
                <div className="container">       
                        <div id="js-grid-juicy-projects" className="cbp">
                            <div className="cbp-item rounded design">
                                <div className="gallery-link">
                                <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/3col-1.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/3col-1.jpg" alt=""/>
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="cbp-item rounded design">
                                <div className="gallery-link">
                                <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/3col-2.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum
                ">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/3col-2.jpg" alt=""/>
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="cbp-item rounded illustration">
                                <div className="gallery-link">
                                <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/3col-3.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum
                ">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/3col-3.jpg" alt=""/>
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="cbp-item rounded photography">
                                <div className="gallery-link">
                                <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/3col-4.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum
                ">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/3col-4.jpg" alt=""/>
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="cbp-item rounded identity">
                                <div className="gallery-link">
                                <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/3col-5.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum
                ">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/3col-5.jpg" alt=""/>
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="cbp-item rounded business">
                                <div className="gallery-link">
                                <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/3col-6.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum
                ">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/3col-6.jpg" alt=""/>
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="cbp-item rounded photography">
                                <div className="gallery-link">
                                <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/3col-7.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/3col-7.jpg" alt=""/>
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="cbp-item rounded business">
                                <div className="gallery-link">
                                <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/3col-8.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/3col-8.jpg" alt=""/>
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="cbp-item rounded business">
                                <div className="gallery-link">
                                <a href="projectsingle" className="txt-white"><i className="icofont-external-link"></i></a>
                                </div>
                                <a href="images/portfolio/3col-9.jpg" className="cbp-caption cbp-lightbox" data-title="Lorem ipsum">
                                    <div className="cbp-caption-defaultWrap">
                                        <img src="images/portfolio/3col-9.jpg" alt=""/>
                                    </div>
                                    <div className="cbp-caption-activeWrap">
                                        <div className="cbp-l-caption-alignCenter">
                                            <div className="cbp-l-caption-body">
                                                <i className="icofont-search icofont-2x txt-white"></i>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>        
                </section>
            </main>
        </>
    );
};
export default Content;
